module.exports = __webpack_public_path__ + "img/logo-los-alamos-bw.54583c5e.png";